module.exports = __webpack_public_path__ + "static/media/logoMenu.d53450bd.svg";